import { j as o } from "../../../../node_modules/react/jsx-runtime.js";
import { clsx as c } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as a } from "../../Typography/Typography.js";
import r from "./NewFileUpload.module.scss.js";
import { useState as p } from "react";
import u from "../../Icon/Icon.js";
const b = ({
  descriptionMessage: s,
  width: n,
  height: d,
  disabled: t,
  isDragActive: i
}) => {
  const [e, l] = p(!1), m = document.documentElement.lang == "en" ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    "Drop or",
    " ",
    /* @__PURE__ */ o.jsx(
      "span",
      {
        style: { color: e ? "" : "var(--color-color-fg-brand-default)" },
        color: e ? "" : "var(--color-brand-primary-default-new)",
        children: "Choose file"
      }
    ),
    " ",
    "to upload"
  ] }) : "اختر ملفًا للتحميل أو اسحبه وأفلته هنا";
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      style: { width: n, height: d },
      "aria-disabled": t,
      className: c(
        r.uploadContainer,
        {
          [r.drag]: i,
          [r.disabled]: t
        },
        "mb-100"
      ),
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      children: [
        /* @__PURE__ */ o.jsx(
          u,
          {
            name: "upload-cloud-02",
            style: { color: e ? "var(--ds-core-color-primary-600)" : "" },
            size: "xxl"
          }
        ),
        /* @__PURE__ */ o.jsx(
          a,
          {
            style: { textAlign: "center" },
            variant: "body-new/medium",
            text: m,
            textColor: "color/fg/bold"
          }
        ),
        /* @__PURE__ */ o.jsx(
          a,
          {
            variant: "body-new/regular",
            text: s,
            textColor: "color/fg/lighter"
          }
        )
      ]
    }
  );
};
export {
  b as default
};
//# sourceMappingURL=FileUploadInput.js.map
